import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaBullhorn,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CommercialAdVideoProductionInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Commercial Ad Video Production in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Boost Your Brand</Subheading>}
        heading={
          <Heading>
            Commercial <span tw="text-primary-500">Ad Video Production</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in commercial ad video production
            in **DIFC**, creating dynamic and high-impact videos that elevate
            your brand and drive conversions. Let your message shine with our
            expert craftsmanship.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1567593810070-7a3d471af022?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Professional commercial filming
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2672&q=80", // Business video production
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial-quality filming
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Produce Your Ad"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Commercial Ad Production in DIFC"
        description="We create commercial ads with precision and creativity."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "Visually stunning ads that captivate viewers.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Professionals",
            description: "Experienced team delivering proven results.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Impactful Storytelling",
            description: "Ads that connect and convert audiences.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Production",
            description: "Timely delivery with exceptional quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for TV, web, and social media.",
          },
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "Marketing Driven",
            description: "Designed to maximize campaign success.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Commercial Ad Production Process"
        description={
          <Description>
            We produce high-impact commercial ads with a refined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Align with your campaign objectives.</li>
              <li>Concept Development: Craft compelling ad concepts.</li>
              <li>Filming: Capture with cutting-edge equipment.</li>
              <li>Editing: Enhance visuals and audio for maximum impact.</li>
              <li>Delivery: Provide polished ads ready for launch.</li>
              <li>Support: Offer ongoing refinements and campaign support.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504465039542-a4622982ad53?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial storyboarding
          "https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Commercial Ad Wins in DIFC"
        description="Our ads have transformed campaigns in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High Engagement",
            description: "Drove conversions with compelling ads.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Reach",
            description: "Amplified visibility for DIFC businesses.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "95% satisfaction from ad campaigns.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for High-Impact Ads?</Subheading>}
        heading="Commercial Ad Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for commercial ad video production in
            DIFC. Create dynamic, high-quality ads that elevate your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1577017040065-650ee4d43339?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai business district
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial filming equipment
          "https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Professional production team
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
